//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Footer from '../components/footer.vue'
    import {
        SaunaKanbanQuery,
        MemberKanbanQuery
    } from '../../static/js/api.js'
    function loadtotal(that) {


        SaunaKanbanQuery({}, function (res) {
            console.log(res)
            if (res.data.IsSuccess) {

                that.data = JSON.parse(res.data.Result)

                var circleData=[];
                var mapData={};


                var arr = JSON.parse(JSON.stringify(that.data.BarConsumeDetails));
                function maxarr(arr,len){
                    var max = [];
                    arr.sort(function(a,b){
                        return a.Money-b.Money;
                    });
                    for(var i=0;i<len;i++){
                        max.push(arr.pop());
                    }
                    return max;
                }



                var datassss=arr

                for(var i=0;i<datassss.length;i++){
                    var item=datassss[i]
                    var newCircle={
                        name: item.BarName,
                        percent: item.Money/that.data.BarConsumeSummary.Money.toFixed(4),
                        a: '1'

                    }
                    mapData[item.BarName]=((item.Money/that.data.BarConsumeSummary.Money).toFixed(4) * 100).toFixed(2)+ '%'
                    circleData.push(newCircle)


                }
                that.datas=circleData
                map=mapData
                that.showChart = true
                
                const chart = new that.F2.Chart({
  id: 'boxCanvas',
  pixelRatio: window.devicePixelRatio
});
chart.source(circleData, {
  percent: {
    formatter: function formatter(val) {
      return val * 100 + '%';
    }
  }
});
chart.legend({
  position: 'right',
  itemFormatter: function itemFormatter(val) {
    return val + '  ' + map[val];
  }
});
chart.tooltip(false);
chart.coord('polar', {
  transposed: true,
  radius: 0.85
});
chart.axis(false);
chart.interval()
  .position('a*percent')
  .color('name', [ '#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864', '#8543E0',"#8AC6D1","#BBDED6","#FAE3D9","#FFB6B9","#f768a2","#fb6a49","#79c77a","#9f9bc9","#979797"])
  .adjust('stack')
  .style({
    lineWidth: 1,
    stroke: '#fff',
    lineJoin: 'round',
    lineCap: 'round'
  })
  .animate({
    appear: {
      duration: 1200,
      easing: 'bounceOut'
    }
  });

chart.render();








                MemberKanbanQuery({}, function (ress) {
                    console.log(ress)
                    if (ress.data.IsSuccess) {

                        that.data.PayDetails = JSON.parse(ress.data.Result).PayDetails
                        console.log(that.data)
                    } else {

                        that.$vux.toast.text('数据获取失败，请重试', 'middle')

                    }


                })



                that.loading=false

                console.log(that.data)
            } else {

                that.$vux.toast.text('数据获取失败，请重试', 'middle')

            }


        })

    }

 var map={}
    export default {
        name: 'app',
        components: {
            'pc-footer': Footer
        },
        data() {
            return {
                loading:true,
                legendOptions: {
                    position: 'right',
                    itemFormatter (val) {
                        return val + '  ' + map[val]
                    }
                },
                yOptions: {
                    formatter (val) {
                        return val * 100 + '%'
                    }
                },
                map,
                datas: [

                ],
                showChart:false,
                data: {
                    GuestFlows: {},
                    BarConsumeDetails: {},
                    BarConsumeSummary: {},
                    ConsumeDetails: {},
                    ConsumeSummary: {},
                    GuestPerConsume: {},
                    HandCardUsed: {},
                    MemberUsedDetail: {},
                    MemberUsedSummary: {},
                    NewMemberDetails: {},
                    NewMemberSummary: {},
                    PayModeDetails: {},
                    PayModeSummary: {
                        Money:1
                    },
                    PrepaidMemberDetails: {},
                    PrepaidMemberSummary: {},
                    PayDetails: {},

                },
                selected:1,
                selectedsr:1,
                msg: 'Welcome to Your Vue.js App',
                nav:[
                    {
                        id:1,
                        name:"人数统计"

                    },
                    {
                        id:2,
                        name:"收入情况"

                    },
                    {
                        id:3,
                        name:"销售类别"

                    },{
                        id:4,
                        name:"吧台统计"

                    }

                ],
                navsr:[


                    {
                        id:1,
                        name:"吧台统计"

                    }


                ]
            }
        },

        mounted() {
            var that = this
            loadtotal(that)


        },
        methods:{

            refresh(){
                this.loading=true
                var that=this
                loadtotal(that)


            },
            change(index){
                console.log(index)
                this.selected= parseInt(index+1)

            },

            changesr(index){
                console.log(index)
                this.selectedsr= parseInt(index+1)

            }


        }

    }



// WEBPACK FOOTER //
// ./src/pages/bt.vue